<template>
  <div class="main_center">
    <div class="content">
      <div class="search-content">
        <div class="mainBtn">
          <el-button size="small"  type="primary"
                     @click="routerAdd"
                     v-if="hasBtnPermission('btn_jz_pm-dgwitness-thirds-config_add')">新增</el-button>
          <el-button @click="deleteSelectItem()"
                     size="small"
                     v-if="hasBtnPermission('btn_jz_pm-dgwitness-thirds-config_delete')">删除
          </el-button>
        </div>
        <div class="searchBtn">
          <span class="label-form">关键字搜索：</span>
          <el-input @keyup.enter.native="searchBtn" clearable placeholder="请输入内容搜索" style="width: 200px" v-model="form.search"></el-input>
          <span class="label-form">接口类型：</span>
          <el-select @change="searchBtn" clearable  style="width:150px;display: inline-block"  v-model="form.interType">
            <el-option :key="item.value" :label="item.name" :value="item.value" v-for="(item,index) in interTypeNameList"></el-option>
          </el-select>
          <span class="label-form">文件获取方式：</span>
          <el-select @change="searchBtn" clearable  style="width:150px;display: inline-block"  v-model="form.fileDownMod">
            <el-option :key="item.value" :label="item.name" :value="item.value" v-for="(item,index) in fileDownModNamelist"></el-option>
          </el-select>
          <el-button @click="searchBtn" size="small" style="margin-left: 12px" type="primary">搜索</el-button>
          <el-divider direction="vertical"></el-divider>
          <el-button @click="refresh" icon="el-icon-refresh" type="text"></el-button>
        </div>
      </div>
      <el-table :data="tableData"
                ref="multipleTable"
                class="table-content"
                :header-cell-style="this.$globalGrayTableHeaderStyle"
                v-loading="dataListLoading"
                :height="tableMaxHeight"
                stripe border
                @selection-change="handleSelectionChange">
                <el-table-column fixed type="selection" v-if="hasBtnPermission('btn_jz_pm-dgwitness-thirds-config_delete')" align="center"
                         :show-overflow-tooltip='true'></el-table-column>
        <el-table-column fixed label="序号" type="index" :index="indexMethod" width="50" align="center"
                         :show-overflow-tooltip='true'></el-table-column>
        
        <el-table-column label="操作" fixed="right" align="center" width="100">
          <template slot-scope="scope">
            <el-button type="text" title="查看"
                       v-if="hasBtnPermission('btn_jz_pm-dgwitness-thirds-config_view')"
                       @click="router(scope.row)">查看</el-button>
            <el-button type="text" title="删除"
                       v-if="hasBtnPermission('btn_jz_pm-dgwitness-thirds-config_delete')"
                       @click="deleteById(scope.row)">
              删除
            </el-button>
          </template>
        </el-table-column>


        <el-table-column label="系统名称" prop='systemName' header-align="center" align="left" min-width='100'
                         :show-overflow-tooltip='true'></el-table-column>
        <el-table-column label="所属单位" prop='orgName' header-align="center" align="center" min-width='100'
                         :show-overflow-tooltip='true'></el-table-column>
        <el-table-column label="访问token" prop='token' header-align="center" align="center" min-width='100'
                         :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column label="访问地址" prop='accessUrl' header-align="center" align="center" min-width='100'
                         :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column label="回调接口" prop='callback' header-align="center" align="center" min-width='100'
                         :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column label="接口密钥" prop='secrets' header-align="center" align="center" min-width='100'
                         :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column label="接口类型" prop='interTypeName' header-align="center" align="center" min-width='100'
                         :show-overflow-tooltip='true'>
          <template slot-scope="scope" >
            <el-tag v-if="scope.row.interType" :type="formatterTagType(scope.row.interType,'interType')" size="small" :hit="false" effect="plain"  > {{scope.row.interTypeName}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="文件获取方式" prop='fileDownModName' header-align="center" align="center" min-width='100'
                         :show-overflow-tooltip='true'>
          <template slot-scope="scope" >
            <el-tag v-if="scope.row.fileDownMod" :type="formatterTagType(scope.row.fileDownMod,'fileDownMod')" size="small" :hit="false" effect="plain"  > {{scope.row.fileDownModName}}</el-tag>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background
                     layout="total, sizes, prev, pager, next"
                     :page-sizes="[10, 20, 50, 100]"
                     :page-size="pageSize"
                     :total="total"
                     :current-page="pageIndex"
                     @size-change="sizeChangeHandle"
                     @current-change="currentChangeHandle"></el-pagination>
    </div>
  </div>
</template>

<script>
    import {mapState} from "vuex";


    export default {
  data() {
    return {
      tableMaxHeight: document.documentElement.clientHeight - 227,
      dataListLoading: false,
      form: {
        search:'' ,//搜索框的值
        interType:'',
        fileDownMod:'',
      },
      interTypeNameList:[],
      fileDownModNamelist:[],
      moreSearchItem: false,
      checkList1: '',
      pageSize: 10,//每页条数
      pageIndex: 1,//当前页
      total: 0,//总条数
      tableData: [],
      multipleSelection: [],
      user: '', //角色类型
      formData: {}
    }
  },
  computed: {
    ...mapState({
      stateData: state => state.user
    }),
  },
  filters: {
    ellipsis(text, num) {
      if (text.length > num) {
        return text.substring(0, num) + '...';
      } else {
        return text;
      }
    },
  },
  activated() {
    //this.user = this.stateData.pageRoleIds //角色类型
    // this.refresh();
    this.getDataList()
    this.getDic('jz_interface_type')
    this.getDic('jz_third_filedownmod')
  },
  mounted() {
    const that = this;
    let resizeTag = true
    window.onresize = () => {
      if (resizeTag) { //防抖动
        that.ifmove();
        resizeTag = false
        setTimeout(() => {
          resizeTag = true
        }, 1000)
      }
    }
    that.ifmove();
  },
  methods: {
    ifmove() {
      // let hasBtnPermisson = this.hasBtnPermission('btn_jz_pm-dgwitness-thirds-config_delete') || this.hasBtnPermission('btn_jz_pm-dgwitness-thirds-config_add');
      let tableMaxHeight = document.documentElement.clientHeight - 227;
      this.pageSize = parseInt((tableMaxHeight) / 50) || 1;
      this.$nextTick(() => {
        this.tableMaxHeight = tableMaxHeight
      })
      //this.getDataList()
    },

    getDic(type){ // 获取字典
      this.$httpReq.get('/sys/dictData/getList?type='+type).then(res=>{
        if(res.data.code==='1'){
          switch(type){
            case 'jz_interface_type':this.interTypeNameList =res.data.data;break;
            case 'jz_third_filedownmod':this.fileDownModNamelist =res.data.data;break;
          }
        }
      })
    },

    getDataList() { // 获取列表数据
      this.dataListLoading=true;
      this.$httpReq.post('/thirdsConfig/list', {
        'page': this.pageIndex,
        'rows': this.pageSize,
        'searchKey': this.form.search,
        'filter': this.form
      }).then(res => {
        this.tableData = res.data.rows;
        this.total = res.data.total;
        this.$refs.multipleTable.doLayout();
        this.dataListLoading=false;
      })
    },

    indexMethod(index) {
      return (this.pageIndex - 1) * this.pageSize + index + 1
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    searchBtn() { //搜索按钮
      this.pageIndex = 1;
      this.pageSize = 10;
      this.getDataList()
    },
    refresh() {//刷新按钮
      this.pageIndex = 1;
      this.form.search = "";
      this.form.fileDownMod="";
      this.form.interType="";

      this.getDataList()

    },

    routerAdd(){ //新增
      window.sessionStorage.setItem("addUpdateIndex",2);

      window.sessionStorage.setItem("id", '');

      this.$router.push({
        name:'thirds_config_detail'
      })

    },

    router(item){ // 跳转详情
      var id = item.id;
      window.sessionStorage.setItem("id", id);
      window.sessionStorage.setItem("addUpdateIndex",1)

      this.$router.push({
        name:'thirds_config_view'
      })

    },



    deleteById(item) {
      this.$confirm(`确定要删除该数据?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$httpReq.post('/thirdsConfig/delete', {
          id: item.id
        }).then(res => {
          if (res.data.code == '1') {
            this.$message({
              type: 'success',
              message: res.data.msg
            })
            this.getDataList();
          } else {
            this.$message({
              type: 'error',
              message: res.data.msg
            })
          }
        })
      })
    },
    deleteSelectItem() {
      let ids = new Array();
      this.multipleSelection.forEach(key => {
        ids.push(key.id)
      })

      if (ids != "" || ids.length > 0) {
        this.$httpReq.post('/thirdsConfig/delete', {
          idList: ids
        }).then(res => {
          if (res.data.code == '1') {
            this.$message({
              type: 'success',
              message: res.data.msg
            })
            this.getDataList();
          } else {
            this.$message({
              type: 'error',
              message: res.data.msg
            })
          }
        })
      } else {
        this.$message({
          type: 'error',
          message: "未选择删除项。"
        })
      }

    },

    sizeChangeHandle(val) {
      this.pageSize = val;
      this.pageIndex = 1
      this.getDataList()
    },

    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    },



  }


}
</script>

<style lang="scss">
.main_center {
  .top {
    .input_title {
      display: flex;
    }

    .el-form-item {
      margin-bottom: 0;
    }
  }
}

.margin-hide {
  .el-form-item__content {
    margin-left: 0 !important;
  }
}
</style>